import axios from "axios";

// Base API URLs
const AUTH_API_URL = "https://api.ipaisa.co.in/myapp/auth";
const ADMIN_API_URL = "https://api.ipaisa.co.in/myapp/admin";

// Helper function to get token
const getToken = () => sessionStorage.getItem("jwtToken");

// Fetch Partners
export const fetchPartners = async (currentPage, pageSize, roleId, setTotalRecords, searchBy, setTotalPages) => {
  try {
    const response = await axios.get(`${AUTH_API_URL}/list`, {
      params: {
        page: currentPage,
        size: pageSize,
        roleid: roleId,
        searchBy: searchBy, // Additional search parameter if needed
      },
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    setTotalRecords(response.data.body.totalElements);
    setTotalPages(response.data.body.totalPages);
    return response.data;
  } catch (error) {
    console.error("Error fetching partners:", error);
    throw error;
  }
};

// Search Users
export const searchUsers = async (searchQuery) => {
  try {
    const response = await axios.get(`${AUTH_API_URL}/searchInUserList`, {
      params: { roleid: 3, searchBy: searchQuery },
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error searching users:", error);
    throw error;
  }
};

// Change Partner Status (Admin API)
export const changePartnerStatus = async (userId, currentStatus) => {
  try {
    const response = await axios.put(
      `${ADMIN_API_URL}/changeStatus/${userId}`, // Use ADMIN API
      { status: currentStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE" },
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating status:", error);
    throw error;
  }
};

// Delete Partner (Admin API)
export const deletePartner = async (userId) => {
  try {
    const response = await axios.delete(`${ADMIN_API_URL}/deletePartner/${userId}`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting partner:", error);
    throw error;
  }
};

// Update User (Admin API)
export const updateUser = async (userData) => {
  try {
    const response = await axios.patch(
      `${AUTH_API_URL}/updateUser`,
      userData,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};
